const keyboardDatePickerModalFilterExpiredServices = {
  from: 'Desde',
  to: 'Hasta'
};

export default keyboardDatePickerModalFilterExpiredServices;
